import { FC } from 'react'
import styled, { css } from 'styled-components'
import { TExamTab } from '@app.feature/exam/constants/tabs'
import useScrollTab from '@app.feature/exam/hooks/useScrollTab'
import ExamTab from './Tab/ExamTab'

interface IFProps {
  companyId: string
  termId: string
  tabOptions: Array<TExamTab>
}

const ExamTabs: FC<IFProps> = ({ companyId, termId, tabOptions }) => {
  const { activeTab } = useScrollTab()
  return (
    <StyledWrapper>
      <ul>
        {tabOptions.map((tab) => {
          return (
            <ExamTab
              key={tab.id}
              tab={tab}
              activeTab={activeTab}
              companyId={companyId}
              termId={termId}
            />
          )
        })}
      </ul>
    </StyledWrapper>
  )
}

export default ExamTabs

const desktopStyles = css`
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 90;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fafafa;
  > ul {
    display: flex;
    gap: 10px;
    width: 1100px;
  }
`

const mobileStyles = css`
  width: 100%;
  position: sticky;
  background-color: #fafafa;
  top: 50px;
  z-index: 250;

  > ul {
    display: flex;
    width: 100%;
    height: 93px;
    > li {
      flex: 1;
    }
  }
`

const StyledWrapper = styled.nav`
  ${({ theme }) => css`
    ${theme.isMobile ? mobileStyles : desktopStyles}
  `}
`
